/** Texte des gemeinsamen Dokument-Viewers; Produkte mischen sie in ihr Wörterbuch (informelle Ansprache). */
export const documentViewerDe = {
  "DocumentViewer.page": "Seite",
  "DocumentViewer.pageOf": "von {total}",
  "DocumentViewer.previousPage": "vorherige Seite",
  "DocumentViewer.nextPage": "nächste Seite",
  "DocumentViewer.zoom": "Zoom",
  "DocumentViewer.zoomOut": "verkleinern",
  "DocumentViewer.zoomIn": "vergrößern",
  "DocumentViewer.fitWidth": "an Breite anpassen",
  "DocumentViewer.fitPage": "ganze Seite",
  "DocumentViewer.rotate": "drehen",
  "DocumentViewer.download": "herunterladen",
  "DocumentViewer.print": "drucken",
  "DocumentViewer.fullscreen": "Vollbild",
  "DocumentViewer.exitFullscreen": "Vollbild beenden",
  "DocumentViewer.more": "weitere Aktionen",
  "DocumentViewer.loading": "Dokument wird geladen …",
  "DocumentViewer.error": "Die Vorschau konnte nicht geladen werden.",
} as const;

export const documentViewerEn = {
  "DocumentViewer.page": "Page",
  "DocumentViewer.pageOf": "of {total}",
  "DocumentViewer.previousPage": "previous page",
  "DocumentViewer.nextPage": "next page",
  "DocumentViewer.zoom": "Zoom",
  "DocumentViewer.zoomOut": "zoom out",
  "DocumentViewer.zoomIn": "zoom in",
  "DocumentViewer.fitWidth": "fit to width",
  "DocumentViewer.fitPage": "whole page",
  "DocumentViewer.rotate": "rotate",
  "DocumentViewer.download": "download",
  "DocumentViewer.print": "print",
  "DocumentViewer.fullscreen": "full screen",
  "DocumentViewer.exitFullscreen": "exit full screen",
  "DocumentViewer.more": "more actions",
  "DocumentViewer.loading": "Loading document …",
  "DocumentViewer.error": "The preview could not be loaded.",
} as const;

export type DocumentViewerTextKey = keyof typeof documentViewerDe;
